<template>
  <div class="feedback">
    <div class="content_box">
      <div class="title">
        <div class="left">
          <img
            src="@/assets/images/feedback/feedback_content.png"
            alt=""
          />反馈内容
        </div>
        <span class="time">{{ data.createTime  }}</span>
      </div>
      <p class="content">{{ data.feedbackContent }}</p>
      <van-uploader
        class="upload"
        v-model="feedbackImage"
        disabled
        :max-count="feedbackImage.length"
        :deletable="false"
        v-if="feedbackImage.length"
      />
    </div>
    <div class="content_box" v-if="data.status === 1">
      <div class="title">
        <div class="left">
          <img
            src="@/assets/images/feedback/reply_content.png"
            alt=""
          />回复内容
        </div>
        <span class="time">{{ data.replyTime }}</span>
      </div>
      <p class="content">{{ data.replyContent }}</p>
      <van-uploader
        v-if="replyImage.length"
        class="upload"
        v-model="replyImage"
        disabled
        :max-count="replyImage.length"
        :deletable="false"
      />
    </div>
  </div>
</template>
<script>
import { feedback } from "@/api/Feedback";
export default {
  name: "Feedback",
  data() {
    return {
      data: {},
      feedbackImage: [],
      replyImage: [],
    };
  },
  created() {
    this.getFeedback();
  },
  mounted() {},
  methods: {
    async getFeedback() {
      let { data } = await feedback(this.$route.query.id);
      data.feedbackImage = data.feedbackImage
        ? data.feedbackImage.split(",")
        : [];
      let feedbackImage = [];
      data.feedbackImage.map((v) => {
        feedbackImage.push({ url: v });
      });
      this.feedbackImage = feedbackImage;
      data.replyImage = data.replyImage ? data.replyImage.split(",") : [];
      let replyImage = [];
      data.replyImage.map((v) => {
        replyImage.push({ url: v });
      });
      this.replyImage = replyImage;
      this.data = data;
    },
  },
};
</script>
<style lang="scss" scoped>
.feedback {
  background: #f5f6fa;
  min-height: calc(100vh - 46px);
  padding: 15px;
  .content_box {
    background: #ffffff;
    border-radius: 5px;
    margin-bottom: 15px;
    padding: 15px;
    .title {
      display: flex;
      font-size: 15px;
      align-items: center;
      padding-bottom: 12px;
      border-bottom: 1px solid #eee;
      justify-content: space-between;
      .left {
        display: flex;
        align-items: center;
        img {
          width: 20px;
          height: 20px;
          margin-right: 4px;
        }
        span {
          font-size: 12px;
          color: #999;
        }
      }
      .time {
        font-size: 13px;
      }
    }
    ::v-deep .upload {
      margin-top: 10px;
      .van-uploader__wrapper--disabled {
        opacity: 1;
      }
    }
  }
  .content {
    margin-top: 5px;
    font-size: 16px;
    line-height: 150%;
  }
}
</style>
